import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../Assets/logo.svg";
import { ReactComponent as DasboardIcon } from "../Assets/dashboard.svg";
import { ReactComponent as TemplateIcon } from "../Assets/templates.svg";
import { ReactComponent as ExperienceIcon } from "../Assets/experience.svg";
import { ReactComponent as UserIcon } from "../Assets/user.svg";
import { ReactComponent as LogoutIcon } from "../Assets/logout.svg";
import { ReactComponent as RunJSIcon } from "../Assets/runjs.svg";
import { ReactComponent as CookiesIcon } from "../Assets/cookies.svg";
import { ReactComponent as ShowTemplatesIcon } from "../Assets/showtemplate.svg";
import { ReactComponent as PageviewIcon } from "../Assets/view.svg";
import { ReactComponent as PagemeterIcon } from "../Assets/pagemeter.svg";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import NationMobile from "../Assets/logo-mobile.svg";
import { useMediaQuery } from "@mui/material";

interface SidebarProps {
  isClosed: boolean;
  setIsClosed: React.Dispatch<React.SetStateAction<boolean>>;
}

const Sidebar: React.FC<SidebarProps> = ({ isClosed, setIsClosed }) => {
  const [activeItem, setActiveItem] = useState("Dashboard");
  const navigate = useNavigate();
  const location = useLocation();
  const userDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
  const grantedPermissions = userDetails?.permissions || [];
  const isMobile = useMediaQuery("(max-width:960px)");

  const hasPermission = (moduleName: string) => {
    return grantedPermissions.some(
      (perm: any) => perm.module === moduleName && perm.granted
    );
  };

  const handleDragStart = (
    e: React.DragEvent,
    item: { name: string; path: string }
  ) => {
    e.dataTransfer.setData("text/plain", item.path);
    e.dataTransfer.setData("is-navigation", "true");
    e.dataTransfer.setData("label", item.name);
    e.dataTransfer.effectAllowed = "copyMove";
  };
  const isEditExperince =
    location.pathname.startsWith("/edit") &&
    !location.pathname.startsWith("/edit-template");
  const menuItems = isEditExperince
    ? [
        {
          name: "Set Cookies",
          icon: <CookiesIcon className="CookiesIcon" />,
          path: "/edit-set-cookie",
        },
        { name: "Run JS", icon: <RunJSIcon className="RunJSIcon" />, path: "/edit-run-js" },
        {
          name: "Show Template",
          icon: <ShowTemplatesIcon className="ShowTemplatesIcon" />,
          path: "/edit-show-template",
        },
        {
          name: "Viewport Exit",
          icon: <PageviewIcon className="PageviewIcon" style={{ height: "16px", width: "16px" }} />,
          path: "/edit-view-port",
        },
        {
          name: "Pageview Meter",
          icon: <PagemeterIcon className="PagemeterIcon" style={{ height: "16px", width: "16px" }} />,
          path: "/edit-page-meter",
        },
        {
          name: "Interaction",
          icon: <PagemeterIcon className="PagemeterIcon" style={{ height: "16px", width: "16px" }} />,
          path: "/edit-interaction",
        },
      ]
    : [
        { name: "Dashboard", icon: <DasboardIcon className="DasboardIcon" />, path: "/dashboard" },
        hasPermission("Template Management") && {
          name: "Templates",
          icon: <TemplateIcon className="TemplateIcon" />,
          path: "/templates/list",
        },
        hasPermission("Experience Management") && {
          name: "Experiences",
          icon: <ExperienceIcon className="ExperienceIcon" />,
          path: "/experience/list",
        },
        { name: "Users", icon: <UserIcon className="UserIcon" />, path: "/users" },
      ].filter(Boolean);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userDetails");
    navigate("/login");
  };

  return (
    <div className={`sidebar ${isClosed ? "sidebar-closed" : "sidebar-open"}`}>
      <div className="sidebar__header" style={{ cursor: "pointer" }}>
        <div className="sidebar__toggle" onClick={() => setIsClosed(!isClosed)}>
          {isClosed ? <NavigateBeforeIcon /> : <KeyboardArrowRightIcon />}
        </div>
        <img
          onClick={() => {
            navigate("/dashboard");
          }}
          src={isClosed ? NationMobile : logo}
          alt="Logo"
        />
        {/* toggle button */}
      </div>

      <div className="sidebar__list">
        {menuItems.map((item) => {
          const isActive =
            location.pathname === item.path ||
            location.pathname.startsWith(item.path);
          return (
            <div
              key={item.name}
              className="sidebar__main"
              draggable
              onDragStart={(e) => handleDragStart(e, item)}
              onClick={() => {
                setActiveItem(item.name);
                if (!isEditExperince) {
                  navigate(item.path);
                }
                if (isMobile) {
                  setIsClosed(true);
                }
              }}
              style={{
                cursor: "grab",
              }}
            >
              <div
                className={`sidebar__item ${
                  isActive ? "sidebar__item--active" : ""
                }`}
              >
                <div className="sidebar__icon">{item.icon}</div>
                <span>{item.name}</span>
              </div>
            </div>
          );
        })}
      </div>
      <div className="sidebar__list">
        <div className="sidebar__main">
          {!isEditExperince ? (
            <div onClick={handleLogout} className="sidebar__item">
              <div className="sidebar__icon">
                <LogoutIcon className="LogoutIcon" />
              </div>
              <span>Logout</span>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
